// extracted by mini-css-extract-plugin
module.exports = {"page":"index-module--page--hv9Kw","breadcrumb":"index-module--breadcrumb--3kdVL","separator":"index-module--separator--1TTyf"};